/**
 * description: 微博定时签发-设置签发时间弹窗
 * author: Qian.qianchen 2018-11-20
 */
'use strict';
angular.module('weiboTimeSignModule', []).controller('weiboTimeSignCtrl', [
    '$scope',
    '$stateParams',
    '$modalInstance',
    'itemArr',
    'trsHttpService',
    'sensitiveWordCheckService',
    '$validation',
    'flowStatus',
    'modalDialog',
    'isSave',
    '$q',
    'editingCenterWeiBoService',
    'weiboApiParams',
    'weiboApiService',
    'globleParamsSet',
    'editingCenterService',
    function(
        $scope,
        $stateParams,
        $modalInstance,
        itemArr,
        trsHttpService,
        sensitiveWordCheckService,
        $validation,
        flowStatus,
        modalDialog,
        isSave,
        $q,
        editingCenterWeiBoService,
        weiboApiParams,
        weiboApiService,
        globleParamsSet,
        editingCenterService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                signTime: '',
                signDate: '',
                timeClear: false,
                dateClear: false,
                isSave: isSave,
                modalTitle: '定时签发',
                isUpdate: false,
            };
            $scope.data = {
                customConfig: {
                    singleDatePicker: true, // 是否是单选框
                    minDate: globleParamsSet.dateFormat(new Date(), '-'),
                }
            };
        }

        /**
         * [initData description]
         * @return  {[type]}  [return description]
         */
        function initData() {
            if (itemArr.length === 1 && itemArr[0].TASKTIME) {
                $scope.status.signDate = itemArr[0].TASKTIME;
                $scope.status.signTime = itemArr[0].TASKTIME;
                $scope.status.isUpdate = true;
            }
        }

        /**
         * [dateFormat description]
         * @param   {[type]}  date     [date description]
         * @param   {[type]}  getType  [getType description]
         * @return  {[type]}           [return description]
         */
        function dateFormat(date, getType) {
            if (angular.isDefined(date) && date != '') {
                var d = new Date(date);
                if (getType == 'date') {
                    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
                } else {
                    return (
                        (d.getHours() > 9 ? d.getHours() : '0' + d.getHours()) +
                        ':' +
                        (d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes()) +
                        ':' +
                        (d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds())
                    );
                }
            } else {
                return '';
            }
        }

        /**
         * [sensitiveWordsCheck description] 敏感词
         * @return  {[type]}  [return description]
         */
        function sensitiveWordsCheck() {
            var defer = $q.defer();
            if ($scope.status.isSave) {
                sensitiveWordCheckService.getSensitiveWordOfContent(itemArr[0].Content).then(function(sensitiveWords) {
                    defer.resolve(sensitiveWords);
                });
            } else {
                editingCenterWeiBoService.hasSensitiveWords(itemArr).then(function(sensitiveWords) {
                    defer.resolve(sensitiveWords);
                });
            }
            return defer.promise;
        }

        /**
         * [submitData description] 数据提交
         * @param   {[type]}  params  [params description]
         * @return  {[type]}          [return description]
         */
        function submitData(params) {
            $scope.loadingPromise = weiboApiService.timeSign(params, true).then(
                function(data) {
                    $modalInstance.close('success');
                },
                function(result) {
                    // $modalInstance.dismiss();
                    var options = {
                        params: params,
                        noAlert: true
                    };
                    editingCenterService.issuedByForce(result, options).then(function(result) {
                        if (result) {
                            $modalInstance.close('success');
                            return;
                        }
                        $modalInstance.dismiss();
                    });
                }
            );
        }

        /**
         * [saveWeibo description] 微博数据保存调用
         * @return  {[type]}  [return description]
         */
        function saveWeibo() {
            var deferred = $q.defer();
            var params = angular.copy(itemArr[0]);
            params.objectId = 0;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWeiboRootUrl(), params, 'post').then(function(docid) {
                deferred.resolve(JSON.parse(docid));
            });
            return deferred.promise;
        }

        /**
         * [timeSign description] 定时签发接口调用
         * @param   {[type]}  params  [params description]
         * @return  {[type]}          [return description]
         */
        function timeSign(params) {
            params.ScheduleTime = dateFormat($scope.status.signDate, 'date') + ' ' + dateFormat($scope.status.signTime, 'time');
            params.methodname = flowStatus == '40' ? 'publishTaskOfDaiBianToJson' : 'publishTaskOfDaiShenToJson';
            sensitiveWordsCheck().then(function(sensitiveWords) {
                if (sensitiveWords.length > 0) {
                    var tips = '';
                    if (itemArr.length == 1) {
                        tips = '该微博包含敏感词,不能定时签发！';
                    } else {
                        tips =
                            '稿件ID为' +
                            sensitiveWords
                                .map(function(item) {
                                    return item.SCMMICROCONTENTID;
                                })
                                .join(',') +
                            '微博包含敏感词,不能定时签发！';
                    }
                    $modalInstance.close({ info: 'error', result: { detail: tips } });
                } else {
                    submitData(params);
                }
            });
        }

        /**
         * [timeIsLegal description]
         * @return  {[type]}  [return description]
         */
        function timeIsLegal() {
            var currTime = new Date();
            var setTime = new Date(Date.parse(dateFormat($scope.status.signDate, 'date') + ' ' + dateFormat($scope.status.signTime, 'time')));
            if (currTime >= setTime) {
                return true;
            } else {
                return false;
            }
        }

        /**
         * [clearDateTime description] 清楚时间
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.clearDateTime = function(type) {
            if (type == 'date') {
                $scope.status.signDate = '';
            } else {
                $scope.status.signTime = '';
            }
        };

        /**
         * [mouseEnter description] 时间控件鼠标进入方法
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.mouseEnter = function(type) {
            if (type == 'date') {
                $scope.status.dateClear = $scope.status.signDate != '';
                $('.date_input').css({ color: '#000' });
            } else {
                $scope.status.timeClear = $scope.status.signTime != '';
            }
        };

        /**
         * [mouseOut description] 时间控件鼠标移除方法
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.mouseOut = function(type) {
            if (type == 'date') {
                $scope.status.dateClear = false;
            } else {
                $scope.status.timeClear = false;
            }
        };

        /**
         * [cancel description] 取消
         * @return  {[type]}  [return description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 表单信息提交-确认
         * @return  {[type]}  [return description]
         */
        $scope.confirm = function() {
            if (!timeIsLegal()) {
                $scope.timeForm.$pending = {};
                let params = angular.extend({}, weiboApiParams.timeSignParams, {
                    AccountIds: angular.isDefined($stateParams.wbchannelid) ? $stateParams.wbchannelid : itemArr[0].PUBLISHACCOUNTIDS,
                });
                $validation.validate($scope.timeForm).success(function() {
                    if ($scope.status.isSave) {
                        saveWeibo().then(function(docid) {
                            params.ObjectIds = docid;
                            timeSign(params);
                        });
                    } else {
                        if ($scope.status.isUpdate) {
                            params = {
                                serviceid: 'wcm61_scmpublishtask',
                                methodname: 'updateSCMMCPublishTaskToJson',
                                PublishTaskId: itemArr[0].SCMMCPUBLISHTASKID,
                                ScheduleTime: dateFormat($scope.status.signDate, 'date') + ' ' + dateFormat($scope.status.signTime, 'time'),
                            };
                            submitData(params);
                        } else {
                            params.ObjectIds = itemArr.map(function(item) {
                                return item.SCMMICROCONTENTID;
                            }).join(',');
                            timeSign(params);
                        }
                    }
                });
            } else {
                modalDialog.alertType('签发失败', '定时发布时间不能早于当前时间，请重新签发！', 'error', false, function() {});
            }
        };
    },
]);
